/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Carrier_Delivery_FailedInputs */

const vi_order_action_carrier_delivery_failed = /** @type {(inputs: Order_Action_Carrier_Delivery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bên vận chuyển báo thất bại`)
};

/**

* @param {Order_Action_Carrier_Delivery_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_carrier_delivery_failed = /** @type {((inputs?: Order_Action_Carrier_Delivery_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Carrier_Delivery_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_carrier_delivery_failed(inputs)
});